import React from "react";
import PropTypes from "prop-types";
import "./index.scss";
import CreateNewFarmContainer from "layouts/CreateNewFarmButton";

const DashboardPanel = ({
  label,
  icon,
  mainCount,
  mainTitle,
  footerLink,
  redirectTo,
  description,
  withButtons,
}) => (
  <section className="dashboard-panel">
    <div
      className={`panel-body ${footerLink === "" ? "" : "-clickable"}`}
      onClick={() => (footerLink !== "" ? redirectTo() : null)}
      aria-hidden
    >
      <div className="header">
        <p className="label">{label}</p>
      </div>
      <h6 className="count" aria-hidden>
        {icon} {mainCount} {mainTitle}
      </h6>
      <div className="description">{description}</div>
      {/* <div className="content" onClick={() => redirectTo()} aria-hidden>
        <p className="link">{footerLink}</p>
      </div> */}
      {withButtons ? (
        <div className="panel-buttons">
          <CreateNewFarmContainer
            buttonColor="green"
            buttonType="solid"
            buttonLabel="Create New"
            buttonSize="medium"
            buttonIcon="add"
          />
        </div>
      ) : null}
    </div>
  </section>
);

DashboardPanel.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  mainCount: PropTypes.string.isRequired,
  mainTitle: PropTypes.string.isRequired,
  footerLink: PropTypes.string.isRequired,
  // footerData: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     id: PropTypes.string.isRequired,
  //     label: PropTypes.string.isRequired,
  //     count: PropTypes.func.isRequired,
  //   })
  // ).isRequired,
  redirectTo: PropTypes.func,
  description: PropTypes.string.isRequired,
  withButtons: PropTypes.string.isRequired,
};
DashboardPanel.defaultProps = {
  redirectTo: {},
};

export default DashboardPanel;
